import React from "react";
import { BackgroundContainer, NavigationContainer, NavigationSideButton, NavigationSideContainer, NavigationToggleButton, SelectSidebarContainerItem, SidebarContainer, SidebarContainerItem } from "../assets/style";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { MainLogoutIcon, MainSideToggle, MainSmileEmoji, SidebarCompanyLogo, SidebarPointer } from "../assets/imgs";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation, useRefreshTokenMutation } from "../features/auth/authApiSlice";
import { useDispatch } from "react-redux";
import { setCredentials } from "../features/auth/authSlice";
import { GlobalStateContext } from '../store/GlobalState';
import { HrproStaff } from "../components/models/HrproStaff";
import ReactLoading from "react-loading";
import { useLazyGetUsersQuery } from "../features/users/usersApiSlice";
import { useLazyCheckUserPermissionQuery } from "../features/remainingWork/remainingWorkApiSlice";

// const MainContent = React.forwardRef(

//   (
//     {
//       navTitle,
//       title,
//       children,
//     }: {
//       navTitle?: React.ReactNode;
//       title?: React.ReactNode;
//       children: React.ReactNode;
//     },
//     ref: React.ForwardedRef<HTMLDivElement>
//   ) => {
//     return (
//       <div className="flex flex-col h-full">
//       </div>
//     );
//   }
// );

// export default MainContent;

const MainContent = React.forwardRef<HTMLDivElement, { style?: React.CSSProperties; children: React.ReactNode; type: String }>((
  { style, children, type }, ref) => {
  const [getUsersQuery, { data: users, error, isLoading, }] = useLazyGetUsersQuery();
  const [refreshToken] = useRefreshTokenMutation();
  const [logout] = useLogoutMutation()
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const globalState = useContext(GlobalStateContext);
  const [showSidebar, setShowSidebar] = useState(false);
  const [user, setUser] = useState<HrproStaff>();
  const [errMsg, setErrMsg] = useState('')
  const errRef = useRef<HTMLInputElement>(null);
  const [checkUserPermissionQuery, checkResult] = useLazyCheckUserPermissionQuery();
  const [permission, setPermission] = useState(false)
  const fetchUserEndpointJson = async () => {
    try {
      if (globalState.token) {
        //await
        getUsersQuery()
          .then((data: any) => {
            if (data.error) {
              // alert('Your session has timed out. Please login again.');
              // localStorage.setItem('token', '');
              // globalState.setToken('');
              // navigate("/");
              // handleRefreshToken();
              window.location.reload();
            }
          });

        const _user = users;
        setUser(_user);
      }
    } catch (err) {
      alert('An error occurred. Please refresh and login again.');
      localStorage.setItem('token', '');
      globalState.setToken('');
      navigate("/");
      window.location.reload();
    }
    // if (error) {
    //   localStorage.setItem('token', '');
    //   navigate("/");
    // }
    // getUsersQuery();
    // if (!error) {
    //   const _user = users;
    //   setUser(_user);
    // } else {
    //   alert('Cannot get user data - An error occurred. Please contact your system administrator.');
    //   localStorage.setItem('token', '');
    //   navigate("/");
    // }
  }

  // const handleRefreshToken = async () => {
  //   try {
  //     // const authorization = `Bearer ${globalState.token}`
  //     // const userData = await refreshToken({ authorization }).unwrap()

  //     localStorage.setItem('token', '');
  //     globalState.setToken('');

  //     const userData = await refreshToken({ user }).unwrap()
  //     dispatch(setCredentials({ user: user, accessToken: userData }))
  //     localStorage.setItem('token', userData)
  //     await globalState.setToken(userData)
  //     navigate('/main')
  //   } catch (err) {
  //     console.log('hehe')
  //     if (!err?.originalStatus) {
  //       setErrMsg('No Server Response');
  //     } else if (err.originalStatus === 400) {
  //       setErrMsg('Missing Username or Password');
  //     } else if (err.originalStatus === 401) {
  //       setErrMsg('Unauthorized');
  //     } else {
  //       setErrMsg('Refresh Failed');
  //     }
  //     errRef.current?.focus();
  //     console.log(errMsg);
  //     navigate('/')
  //   }
  // }
  const handleShowsideBar = (event: any) => {
    const opposite = !showSidebar
    setShowSidebar(opposite)
  }

  const handleOverview = (event: any) => {
    // const opposite = !showSidebar
    // setShowSidebar(opposite)
    navigate("/main")
  }

  const handleErrorLog = (event: any) => {
    // const opposite = !showSidebar
    // setShowSidebar(opposite)
    navigate("/errorLog")
  }
  const handleResult = (event: any) => {
    // const opposite = !showSidebar
    // setShowSidebar(opposite)
    navigate("/result")
  }

  const handleManagePermission = (event: any) => {
    // const opposite = !showSidebar
    // setShowSidebar(opposite)
    navigate("/managePermission")
  }

  useEffect(() => {
    // console.log("effect in main Content")
    const storedToken = localStorage.getItem('token');
    if (storedToken == "") {
      navigate("/");
      return; // not needed to fetch data
    }
    globalState.setToken(storedToken);

    if (globalState.token === "") {
      navigate("/");
      return; // not needed to fetch data
    }

    if (user == null && !isLoading && !error) {
      fetchUserEndpointJson().catch(() => {
        navigate("/");
      });
    }
    handlePermission(user?.eeNo)
    // const intervalId = setInterval(async () => {
    //   await handleRefreshToken();
    // }, 86400000); // 15 minutes in milliseconds 86400000

    // return () => {
    //   clearInterval(intervalId);
    // };
  }, [users, user, globalState.token]);

  const handleLogout = async (event: any) => {
    const confirmed = window.confirm('Are you sure you want to log out?');
    if (confirmed) {
      try {
        const userData = + logout({ user }).unwrap()
        dispatch(setCredentials({ accessToken: userData, user }))
        localStorage.setItem('token', '')
        globalState.setToken('')
        // setShouldToggleEffect(true);
        window.location.replace('/');
        // navigate('/')
      } catch (err) {
        if (!err?.originalStatus) {
          setErrMsg('Cannot logout - An error occurred. Please contact your system administrator.');
          errRef.current?.focus();
          console.log(errMsg);
          localStorage.setItem('token', '')
          globalState.setToken('')
          window.location.replace('/');
          // navigate('/')
        }
      }
    }
  }

  const handlePermission = async (staffId: any) => {
    checkUserPermissionQuery(staffId).then(res => {
      if (res.data)
        handleTestResultData()
    })
  }

  const handleTestResultData = async () => {
    setPermission(true)
  }
  // useEffect(() => {
  //   checkUserPermissionQuery(user?.eeNo as string).then(res => {
  //     if (res.data)
  //       setPermission(true)
  //     else
  //       setPermission(false)
  //   })
  // }, []);

  // const result = checkUserPermissionQuery(!!user?.eeNo).then(res => {
  //   if (res.data)
  //     setPermission(true)
  //   else
  //     setPermission(false)
  // })
  return (
    <>
      <div style={style}>
        {/* <label>ManagePermission</label> */}
        <SidebarContainer style={{ zIndex: 1, display: showSidebar ? 'block' : 'none' }}>
          <img src={SidebarCompanyLogo} style={{ paddingTop: '14px', paddingLeft: '20px', paddingBottom: '29px' }} alt="company logo" />
          {type == 'main' ?
            <SelectSidebarContainerItem>
              <span>Overview</span>
              {type == 'main'}
              <img src={SidebarPointer} alt="pointer" />
            </SelectSidebarContainerItem>
            :
            <SidebarContainerItem onClick={handleOverview}>
              <span>Overview</span>
              {type == 'main'}
            </SidebarContainerItem>
          }

          {type == 'error' ?
            <SelectSidebarContainerItem>
              <span>Error log</span>
              {type == 'error'}
              <img src={SidebarPointer} alt="pointer" />
            </SelectSidebarContainerItem>
            :
            <SidebarContainerItem onClick={handleErrorLog}>
              <span>Error log</span>
              {type == 'error'}
            </SidebarContainerItem>
          }

          {type == 'result' ?
            <SelectSidebarContainerItem>
              <span>Result</span>
              {type == 'result'}
              <img src={SidebarPointer} alt="pointer" />
            </SelectSidebarContainerItem>
            :
            <SidebarContainerItem onClick={handleResult}>
              <span>Result</span>
              {type == 'result'}
            </SidebarContainerItem>
          }

          {permission && (type == 'manage' ?
            <SelectSidebarContainerItem>
              <span>Manage Permission</span>
              {type == 'manage'}
              <img src={SidebarPointer} alt="pointer" />
            </SelectSidebarContainerItem>
            :
            <SidebarContainerItem onClick={handleManagePermission}>
              <span>Manage Permission</span>
              {type == 'manage'}
            </SidebarContainerItem>
          )}

        </SidebarContainer>

        {/* TOP BAR */}
        <NavigationContainer sx={{ marginLeft: showSidebar ? '250px' : '0px' }}>
          <NavigationToggleButton onClick={handleShowsideBar}>
            <img src={MainSideToggle} alt="toggle" style={{ height: '15px' }} />
          </NavigationToggleButton>
          <NavigationSideContainer display="flex" sx={{ alignItems: 'center' }}>
            <img src={MainSmileEmoji} alt="emoji" style={{ paddingRight: '8px' }} />
            {/* <span>Hello, {user?.surName} {user?.otherName} <br />{user?.roles}</span> */}
            {user?.surName ? <span>Hello, {user?.surName} {user?.otherName} <br />{user?.roles}</span> : <ReactLoading type={"bubbles"} color={'#000000'} />}
            {/* {user?.eeNo == "03274" &&
              <NavigationSideButton onClick={handleManagePermission} >
                <ManageAccountsIcon fontSize="large" />
                &nbsp; <span>Manage <br />Permission</span>
              </NavigationSideButton>
            } */}
            <NavigationSideButton onClick={handleLogout} >
              <img src={MainLogoutIcon} alt="logout" /> &nbsp; Logout
            </NavigationSideButton>
          </NavigationSideContainer>
        </NavigationContainer>

      </div>
      {/* {children} */}
      <BackgroundContainer sx={{ zIndex: 0 }}>
        <div
          ref={ref}
          style={{
            marginLeft: showSidebar ? "250px" : "0px",
          }}
        >
          {children}
        </div>
      </BackgroundContainer>
    </>
  )
});
export default MainContent;
